module.exports = __webpack_public_path__ + "img/airwaves.4a43b58c.png";